module.exports = __webpack_public_path__ + "static/Buy on solv-60f785d654d9e3cc77efd464c45b7df8.png";